// $('.accordion').on('shown.bs.collapse', function() {
//     var href = $(this).find('.collapse.show');


//     $('html, body').animate({
//         scrollTop: $(href).offset().top - 100

//     }, '200');
// })$('.panel-collapse').on('show.bs.collapse', function(e) {

if ($('.sec-career-tabs').length) {

    $('[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        var href = $(this).attr('href');
        console.log('offsetww', $(href).parent().parent().offset().top)
        $('html, body').animate({
            scrollTop: $(href).parent().parent().offset().top

        }, '200');
    })
    $("body").delegate('[data-toggle="collapse"]', "click", function() {

        $('html, body').animate({
            scrollTop: $(this).offset().top

        }, 'slow');
    })


    $('.less-text').hide();
    $('.collapse').on('shown.bs.collapse', function(e) {

        // alert('show');

        let $panel = $(this).closest('.card');
        let $open = $(this).closest('.accordion').find('.collapse.show');
        // $open.addClass('asssss')
        let additionalOffset = 0;
        if ($panel.prevAll().filter($open.closest('.card')).length !== 0) {
            additionalOffset = $open.height();

        }
        $('html,body').animate({
            scrollTop: $panel.offset().top - additionalOffset
        }, 500);
    });

    $('.collapse').on('show.bs.collapse', function(e) {
        // alert('shooooow');
        let $panel = $(this).closest('.card');
        // var $open = $(this).closest('.accordion').find('.collapse.show');
        // $open.addClass('asssss')
        let $ebtn = $panel.find('.card-header').find('.ebtn-alt');
        // $ebtn.addClass('yeeeeeeeeeeeees')
        $ebtn.find('.more-text').hide();
        $ebtn.find('.less-text').show();

    });

    $('.collapse').on('hide.bs.collapse', function() {
        let $panel = $(this).closest('.card');
        let $ebtn = $panel.find('.card-header').find('.ebtn-alt');
        // $ebtn.removeClass('yeeeeeeeeeeeees')
        $ebtn.find('.less-text').hide();
        $ebtn.find('.more-text').show();
    })
}